import NeonFlipClock from "./NeonFlipClock";
import HourlyWeatherCards from "./HourlyWeatherCards";
import DayDateCards from "./DayDateCards";

export default function App() {
  return (
    <div
      style={{        
        padding: "2rem",
        textAlign: "center",
      }}
    >
      <DayDateCards neonColor="rgba(170, 179, 170, 1)" />
 <div style={{ marginTop: "2rem" ,marginBottom: "2rem"}}>
        <NeonFlipClock format="[hh]:[mm]:[ss][A]" neonColor="#0f0" />
      </div>
      {/* Vermont 05401 approx lat/lon */}
      <HourlyWeatherCards lat="44.4759" lon="-73.2121" neonColor="rgba(188, 197, 188, 1)" />

     


    </div>
  );
}
